import { FC } from 'react';
import { IFormProps } from '.';
import TitleControlViewModel from '../Models/TitleControlViewModel';
import st from '../DynamicForm.module.scss';

interface ITitleControlProps extends IFormProps {
	model: TitleControlViewModel;
}

const TitleControl: FC<ITitleControlProps> = ({ model }) => {
	if (!model.ControlVisibility) {
		return null;
	}

	if (model.ControlKey === 'Label') {
		// превращаем переводы строк в Label в <br />, чтобы они корректно отображались
		const caption = model.Caption ?? '';
		const htmlCaption = caption
			.replace(/\r\n/g, '\n')
			.replace(/\\n/g, '<br />')
			.replace(/\n/g, '<br />');

		return (
			<h3
				className={st.title}
				hidden={!model.ControlVisibility}
				dangerouslySetInnerHTML={{ __html: htmlCaption }}
			/>
		);
	} else {
		return (
			<h3 className={st.title} hidden={!model.ControlVisibility}>
				{model.Caption}
			</h3>
		);
	}
};

export default TitleControl;
